export function filterParticipantsInOverlappingShifts(shift, accountIds) {
    return [
        { column: 'status', op: '=', value: 'approved' },
        { column: 'shiftId', op: '!=', value: shift.id },
        {
            column: 'participantId',
            op: 'in',
            value: accountIds,
        },
        { column: 'shiftStartTime', op: '<', value: shift.columns.stopTime },
        { column: 'shiftStopTime', op: '>', value: shift.columns.startTime },
    ];
}
